import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import Client from "../../models/client";

import {
  CREDIT_NOTES_CREATE,
  CREDIT_NOTES_UPDATE,
  DEBIT_NOTES_CREATE,
  DEBIT_NOTES_UPDATE,
  INVOICES_CREATE,
  INVOICES_UPDATE,
  RECEIPTS_CREATE,
  RECEIPTS_UPDATE,
  REMISSION_NOTES_CREATE,
  REMISSION_NOTES_UPDATE,
} from "../../auth/permissions";
import HasAnyPermissionComponent from "../permissions/HasAnyPermissionComponent";

interface ClientCrudAtionsProps {
  client: Client;
  onUpdateClick: (_: Client) => void;
  onDeleteClick: (_: Client) => void;
}

const ClientCrudActions: React.FC<ClientCrudAtionsProps> = ({
  client,
  onUpdateClick,
  onDeleteClick,
}) => {
  const editButton = (
    <HasAnyPermissionComponent
      permissionNames={[
        INVOICES_CREATE,
        INVOICES_UPDATE,
        CREDIT_NOTES_CREATE,
        CREDIT_NOTES_UPDATE,
        DEBIT_NOTES_CREATE,
        DEBIT_NOTES_UPDATE,
        REMISSION_NOTES_CREATE,
        REMISSION_NOTES_UPDATE,
        RECEIPTS_CREATE,
        RECEIPTS_UPDATE,
      ]}
    >
      <CTooltip content={"Editar"}>
        <CButton
          className="text-white"
          color="warning"
          onClick={() => {
            onUpdateClick(client);
          }}
        >
          <i className="fa fa-pencil"></i>
        </CButton>
      </CTooltip>
    </HasAnyPermissionComponent>
  );
  const deleteButton = (
    <HasAnyPermissionComponent
      permissionNames={[
        INVOICES_CREATE,
        INVOICES_UPDATE,
        CREDIT_NOTES_CREATE,
        CREDIT_NOTES_UPDATE,
        DEBIT_NOTES_CREATE,
        DEBIT_NOTES_UPDATE,
        REMISSION_NOTES_CREATE,
        REMISSION_NOTES_UPDATE,
        RECEIPTS_CREATE,
        RECEIPTS_UPDATE,
      ]}
    >
      <CTooltip content={"Eliminar"}>
        <CButton
          className="text-white"
          color="danger"
          onClick={() => {
            onDeleteClick(client);
          }}
        >
          <i className="fa fa-trash"></i>
        </CButton>
      </CTooltip>
    </HasAnyPermissionComponent>
  );

  const shouldShowEditAndDeleteButton = true;

  return (
    <td className="text-center">
      <CButtonGroup>
        {shouldShowEditAndDeleteButton ? (
          <>
            {editButton}
            {deleteButton}
          </>
        ) : (
          <></>
        )}
      </CButtonGroup>
    </td>
  );
};

export default ClientCrudActions;
